import Swiper from "swiper";

const swiperInstances = [];
let activeStep = 1;

function updateStepSwiper(activeStep) {
  document
    .querySelectorAll(".step-by-step-swiper .swiper-slide")
    .forEach((slide) => {
      slide.classList.remove("active");
    });

  const targetSlide = document.querySelectorAll(
    `.step-by-step-swiper .swiper-slide[data-js-target="step-${activeStep}"]`
  );
  if (targetSlide) {
    targetSlide.forEach((item) => {
      item.classList.add("active");
    });
  }

  swiperInstances.forEach((swiper) => {
    swiper.slideTo(activeStep - 1);
  });
}

function resetAllSteps() {
  const steps = document.querySelectorAll(".page-checkout .single-step");
  steps.forEach((step) => step.classList.remove("active"));
}

function activateStep(step) {
  activeStep = step;

  resetAllSteps();

  const stepContainer = document.querySelector(`.single-step.step-${step}`);
  const stepsCheckoutContainer = document.querySelector(
    ".page-checkout .content-page-checkout"
  );
  const resumeContainer = document.querySelector(
    ".page-checkout .resume-checkout"
  );
  const feedbackContainer = document.querySelector(
    ".page-checkout .feedback-checkout"
  );
  const headerCheckout = document.querySelector(
    ".page-checkout .header-checkout"
  );

  if (step >= 1 && step <= 4) {
    if (stepContainer) stepContainer.classList.add("active");
    stepsCheckoutContainer.classList.add("active");
    resumeContainer.classList.remove("active");
    feedbackContainer.classList.remove("active");
    headerCheckout.classList.add("active");

    if (step === 3) {
      const divState = jQuery(".single-step.step-3 .white-card-address");
      const state = divState.data("state");
      const $listRegisterFirst = jQuery(".list-shipping-options");
      $.ajax({
        url: my_ajax_object.ajax_url,
        method: "POST",
        dataType: "json",
        data: {
          action: "get_shipping_methods_by_region",
          state: state,
        },
        beforeSend() {
          $listRegisterFirst.html(
            '<div class="loading">Carregando opções de entrega…</div>'
          );
        },
        success(resp) {
          if (resp.success) {
            $listRegisterFirst.html(resp.data.html);
            jQuery(".single-step.step-2").removeClass("active");
            jQuery(".single-step.step-3").addClass("active");
          } else {
            alert(resp.data.message);
            $listRegisterFirst.empty();
          }
        },
        error() {
          alert("Ocorreu um erro ao carregar as opções de entrega.");
          $listRegisterFirst.empty();
        },
      });
    }
  }

  updateStepSwiper(activeStep);
}

function changeStepsCheckout() {
  const stepByStepSwipers = document.querySelectorAll(".step-by-step-swiper");
  stepByStepSwipers.forEach((swiper) => {
    const instance = new Swiper(swiper, {
      slidesPerView: "auto",
      spaceBetween: 13,
    });
    swiperInstances.push(instance);
  });

  const pageCheckout = document.querySelector(".page-checkout");
  if (!pageCheckout) return;

  const buttonChangeAddress = document.querySelector(
    ".page-checkout .button-change-address"
  );

  buttonChangeAddress.addEventListener("click", (event) => {
    event.preventDefault();
    activateStep(2);
  });

  pageCheckout.addEventListener("click", (event) => {
    const target = event.target.closest(".button-change-step");
    const goBack = event.target.closest(".button-back");

    if (target) {
      event.preventDefault();
      const dataStep = parseInt(target.getAttribute("data-js-step") || "1", 10);

      // se estamos no step 1, primeiro salva os dados via AJAX
      if (dataStep === 1) {
        const form = document.querySelector(
          ".single-step.step-1 form.personal-infos"
        );
        const formData = new FormData(form);

        fetch(wc_add_to_cart_params.ajax_url, {
          method: "POST",
          credentials: "same-origin",
          headers: { "X-Requested-With": "XMLHttpRequest" },
          body: new URLSearchParams({
            action: "update_personal_info",
            registerName: formData.get("registerName"),
            registerEmail: formData.get("registerEmail"),
            registerPhone: formData.get("registerPhone"),
          }),
        })
          .then((response) => {
            return response.text().then((text) => {
              try {
                return JSON.parse(text);
              } catch (e) {
                console.error("Não foi possível dar parse em JSON:", e);
                throw new Error("Resposta inválida do servidor");
              }
            });
          })
          .then((resp) => {
            if (resp.success) {
              activateStep(dataStep + 1);
            } else {
              alert("Erro ao salvar seus dados: " + resp.data);
            }
          })
          .catch((error) => {
            console.error("Erro na requisição AJAX:", error);
          });
      } else {
        if (dataStep < 6) {
          activateStep(dataStep + 1);
        }
      }
    }

    if (goBack) {
      event.preventDefault();
      if (activeStep > 1) {
        activateStep(activeStep - 1);
      }
    }
  });
}

export { changeStepsCheckout };
